document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.classList.contains('combined-product')) {
    console.error('Body does not have the class "combined-product".');
    return;
  }
  console.log('Combined product page detected.');

  const accessToken = 'f9ec36d2965ed6ae46a35ddd901f7f69';
  const storeDomain = '/api/2023-10/graphql.json';

  function extractNumericId(gid) {
    const match = gid.match(/\/(\d+)$/);
    return match ? match[1] : null;
  }


  async function fetchProductData(variantId) {
    const variantGID = `gid://shopify/ProductVariant/${variantId}`;
    const query = `
      {
        node(id: "${variantGID}") {
          ... on ProductVariant {
            id
            image { id url altText }
            product {
              vendor
              title
              descriptionHtml
              metafield(namespace: "collection-display", key: "ce_hours") { value }
              featuredImage { id url altText }
            }
          }
        }
      }
    `;
    try {
      const res = await fetch(storeDomain, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': accessToken,
        },
        body: JSON.stringify({ query }),
      });
      const json = await res.json();
      if (json.errors) {
        console.error('GraphQL Errors:', json.errors);
        return null;
      }
      return json.data.node;
    } catch (e) {
      console.error('API Fetch Error:', e);
      return null;
    }
  }

  const variantSelector    = document.querySelector('form[action^="/cart/add"] select[name="id"]');
  const descriptionElement = document.querySelector('.product-description');
  const galleryElement     = document.querySelector('.product_gallery');

  if (!variantSelector || !descriptionElement || !galleryElement) {
    console.error('Required DOM elements not found.');
    return;
  }

  // initialize Flickity once
  let flkty = Flickity.data(galleryElement) ||
              new Flickity(galleryElement, {
                cellAlign: 'left',
                contain: true,
                pageDots: false,
                wrapAround: true,
              });
  console.log('Flickity initialized:', flkty);

  // pick initial variant from URL or selector
  const urlParams = new URLSearchParams(window.location.search);
  const initialId = urlParams.get('variant') || variantSelector.value;
  variantSelector.value = initialId;

  async function updateContent(variantId) {
    console.log('--- Updating Content for variant:', variantId);
    const data = await fetchProductData(variantId);
    if (!data) return console.error('Variant data not available.');

    // 1) Update description
    if (data.product.descriptionHtml) {
      descriptionElement.innerHTML = data.product.descriptionHtml;
    } else {
      descriptionElement.textContent = 'Description not available.';
    }

    // 2) Update CE hours
    const ceElem = document.querySelector('.credit-hours');
    if (ceElem) {
      const ce = data.product.metafield?.value;
      ceElem.textContent = ce ? `CE: ${ce} Hour(s)` : 'CE: vary Hour(s)';
    }

    // 2b) Update Vendor (Provided by)
    const vendorName = data.product.vendor || '';
    if (vendorName) {
      // Try to update the text block "Provided by: ..."
      const providedByP = Array.from(document.querySelectorAll('.product__details p'))
        .find(p => /Provided by:/i.test(p.textContent || ''));
      if (providedByP) {
        providedByP.innerHTML = `<strong>Provided by:</strong> ${vendorName}`;
      }
      // Also update the vendor block if present
      const vendorSpan = document.querySelector('p.vendor span.vendor, .product__details .vendor span.vendor');
      if (vendorSpan) {
        const vendorLink = vendorSpan.querySelector('a');
        if (vendorLink) vendorLink.textContent = vendorName; else vendorSpan.textContent = vendorName;
      }
    }

    // 3) Slide matching
    const mediaCells = galleryElement.querySelectorAll('.gallery-cell');
    let matchIndex = -1, matchCell = null;
    const vidStr = variantId.toString();

    // try variant-id match
    mediaCells.forEach((cell, i) => {
      if (cell.dataset.variantId === vidStr) {
        matchIndex = i; matchCell = cell;
      }
    });
    // if none, try media-id match to data.image.id
    if (matchIndex === -1 && data.image?.id) {
      const mid = extractNumericId(data.image.id);
      mediaCells.forEach((cell, i) => {
        if (cell.dataset.mediaId === mid) {
          matchIndex = i; matchCell = cell;
        }
      });
    }

    // if still none, try alt-text match (image alt equals sub-product title)
    if (matchIndex === -1 && data.product?.title) {
      const desiredAlt = (data.product.title || '').trim().toLowerCase();
      mediaCells.forEach((cell, i) => {
        if (matchIndex !== -1) return;
        const img = cell.querySelector('img.product-gallery__image');
        const alt = (img?.alt || '').trim().toLowerCase();
        if (alt && alt === desiredAlt) {
          matchIndex = i; matchCell = cell;
        }
      });
      console.log('Alt-text match attempt for', desiredAlt, '→ index', matchIndex);
    }

    if (matchIndex !== -1) {
      console.log('✅ Matching slide found at index:', matchIndex);
      const old = galleryElement.querySelector('.gallery-cell.is-selected');
      if (old) { old.classList.remove('is-selected'); old.style.opacity = 0; }
      matchCell.classList.add('is-selected');
      matchCell.style.opacity = 1;
      flkty.select(matchIndex, false, true);
      flkty.resize();

     } else {
    console.warn('No matching slide found for this variant — falling back to featuredImage.');
  
    // 1️⃣ Get the sub‑product’s own featuredImage
    const fb = data.product.featuredImage;
    if (!fb || !fb.id) {
      console.error('No featuredImage on this variant, giving up.');
      return;
    }
    const fbNumId = extractNumericId(fb.id);
  
    // 2️⃣ Find the gallery-cell whose data-media-id matches
    const cells = Array.from(galleryElement.querySelectorAll('.gallery-cell'));
    const fbCellIndex = cells.findIndex(c => c.dataset.mediaId === fbNumId);
    const fbCell      = cells[fbCellIndex];
  
    if (fbCell) {
      // 3️⃣ Swap in the featuredImage URL & alt
      const img = fbCell.querySelector('img.product-gallery__image');
      if (img) {
        img.src             = fb.url;
        img.alt             = fb.altText || '';
        img.dataset.zoomSrc = fb.url;  // if you have zoom enabled
        console.log(`⚙️ Falling back to featuredImage on slide ${fbCellIndex}`);
      }
  
      // 4️⃣ Tell Flickity to go there
      flkty.select(fbCellIndex, false, true);
      flkty.resize();
    } else {
      console.error('❌ Couldn’t find any slide with that featuredImage id, so we’re still stuck on slide 0.');
      flkty.select(0, false, true);
      flkty.resize();
    }
  }



    // 4) Notify curriculum-course.js
    document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId } }));
    setTimeout(() => flkty.resize(), 300);

  }

  // initial load
  updateContent(initialId);
  // Fire already-in-cart asset listener to re-check on combined load
  document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: initialId } }));

  // on user change
  variantSelector.addEventListener('change', e => {
    const vid = e.target.value;
    updateContent(vid);
    const u = new URL(window.location);
    u.searchParams.set('variant', vid);
    window.history.replaceState({}, '', u);
  });

});